import React, {useState} from "react";
import {
    Box,
    Button,
    IconButton,
    CircularProgress,
    Link,
    Grid,
    Card,
    CardHeader,
    CardContent,
    TextField
} from "@mui/material";
import GenericCard from "../UI/GenericCard";
import BallotIcon from '@mui/icons-material/Ballot';

const FormIncoterm = (props) => {
    const {incoterm, title, setPage, onSubmit, isLoading } = props;
    const [code, setCode] = useState(incoterm?.code || '');
    const [name, setName] = useState(incoterm?.name || '');

    const handleSubmit = () => {
        let values = {code, name}
        if(incoterm?.id) values.id = incoterm.id
        onSubmit(values)
    }

    return (
        <>
            <Link className='mt-12' component='button' onClick={() => setPage('listIncoterms')} sx={{marginBottom: '20px'}}>{'< Regresar'}</Link>
            <GenericCard title={title}>
                <Box>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ maxWidth: 345 }}>
                                <CardHeader
                                    sx={{backgroundColor: "#eceff1"}}
                                    avatar={<IconButton aria-label="settings"><BallotIcon /></IconButton>}
                                    title="Code"
                                />
                                <CardContent>
                                    <TextField size="small" label="Ingrese code" fullWidth value={code} sx={{ marginTop: '10px'}} onChange={(e) => setCode(e.target.value)} />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ maxWidth: 345 }}>
                                <CardHeader
                                    sx={{backgroundColor: "#eceff1"}}
                                    avatar={<IconButton aria-label="settings"><BallotIcon /></IconButton>}
                                    title="Nombre"
                                />
                                <CardContent>
                                    <TextField size="small" label="Ingrese nombre" fullWidth value={name} sx={{ marginTop: '10px'}} onChange={(e) => setName(e.target.value)} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    {isLoading ?
                        <CircularProgress />:
                        <Button variant="outlined"  sx={{marginTop: "40px", marginRight: "5px"}} onClick={handleSubmit} disabled={!code && !name}>Guardar Unidad</Button>
                    }
                </Box>
            </GenericCard>
        </>

    )
}

export default FormIncoterm